import { runEvalScript } from "../helpers/runEvalScritp";

export async function getSystemData(){
  return await runEvalScript("$._blingsio.dataManager.getSystemData()");
}
export async function getProject(){
  return await runEvalScript("$._blingsio.dataManager.getProject()");
}